import Helper from '@/services/helper';

export default {
    async submitContact(param) {
        const result = await Helper.postAPI(Helper.apiUrl(), '/api/contact/submit', param);
        
        return result;
    },
}